module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dGT9M"))).then(() => parcelRequire('f4eak'));